import React, { useEffect, useState } from 'react';
import { Row, Col, Switch, DatePicker, Spin } from 'antd';
import MetricBox from '../components/UI/MetricBox';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { useGetBoxMetricsQuery } from '../redux/api/genericReporting';
import { setCompareStartAndEndDate } from '../redux/store/genericReportingSlice';

function BoxMetrics({ suffixStr = '', includeCompare = true }) {
    const dispatch = useDispatch();
    const [switchState, setSwitchState] = useState(false);

    const selectedClient = useSelector(state => state.genericReporting.selectedDropdownValues['client_name']);
    const selectedStartDate = useSelector(state => state.genericReporting.selectedDropdownValues['start_date']);
    const selectedEndDate = useSelector(state => state.genericReporting.selectedDropdownValues['end_date']);
    const compareStartDate = useSelector(state => state.genericReporting.selectedDropdownValues['compare_start_date']);
    const compareEndDate = useSelector(state => state.genericReporting.selectedDropdownValues['compare_end_date']);

    const { data: boxData, status } = useGetBoxMetricsQuery({
        client: selectedClient,
        startDate: selectedStartDate,
        endDate: selectedEndDate,
        compareStartDate,
        compareEndDate,
        suffixStr
    });

    useEffect(() => {
        if (selectedStartDate && selectedEndDate) {
            const tmpStartDate = dayjs(selectedStartDate);
            const tmpEndDate = dayjs(selectedEndDate);
            const daysInSelectedRange = tmpEndDate.diff(tmpStartDate, 'days');
            const newCompareStartDate = tmpStartDate.subtract(daysInSelectedRange + 1, 'days').format('YYYY-MM-DD');
            const newCompareEndDate = tmpEndDate.subtract(daysInSelectedRange + 1, 'days').format('YYYY-MM-DD');
            dispatch(setCompareStartAndEndDate([newCompareStartDate, newCompareEndDate]));
        }
    }, [selectedClient, selectedStartDate, selectedEndDate, switchState]);

    return (
        <div style={{ width: '100%', maxWidth: '85vw' }}>
            {includeCompare && (
                <>
                    <hr />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: '1rem' }}>
                        <h3 style={{ marginRight: '1rem' }}>Manual Compare Range</h3>
                        <Switch checked={switchState} onChange={setSwitchState} style={{ marginRight: '1rem' }} />
                        {switchState && (
                            <DatePicker.RangePicker
                                value={[dayjs(compareStartDate), dayjs(compareEndDate)]}
                                onChange={(dates) => dispatch(setCompareStartAndEndDate([dates[0].format('YYYY-MM-DD'), dates[1].format('YYYY-MM-DD')]))}
                            />
                        )}
                    </div>
                </>
            )}
            {status === 'fulfilled' ? (
                boxData.length > 0 ? (
                    boxData.reduce((rows, box, index) => {
                        if (index % 6 === 0) rows.push([]);
                        rows[rows.length - 1].push(box);
                        return rows;
                    }, []).map((row, rowIndex) => (
                        <Row key={rowIndex} gutter={[16, 16]} justify="center" style={{
                            marginBottom: '1em'
                        }}>
                            {row.map((box, index) => (
                                <Col key={index} xs={24} sm={12} md={8} lg={6} xl={4}>
                                    <MetricBox title={box.title} value={box.value} popValue={(box.pop * 100).toFixed(2)} isInverted={box.is_inverted} />
                                </Col>
                            ))}
                        </Row>
                    ))
                ) : (
                    <Row justify="center"><Col span={24} style={{ textAlign: 'center' }}>No data available</Col></Row>
                )
            ) : status === 'rejected' ? (
                <Row justify="center"><Col span={24} style={{ textAlign: 'center' }}>There was an error fetching the data</Col></Row>
            ) : (
                <Row justify="center"><Col span={24} style={{ textAlign: 'center' }}><Spin /></Col></Row>
            )}
        </div>
    );
}

export default BoxMetrics;
